import authServices from '@services/auth';
import { prefixedKey } from '@tools/localStorage';
import { TOKEN_STORAGE_KEY } from '@tools/constants';

/*
  Derived rather than written out, so it cannot drift from the key the auth reducer persists to.
  The reducer's storage sync removes the key too; this stays because the removal has to happen even
  if a reducer never runs.
*/
const clearStoredToken = () => localStorage.removeItem(prefixedKey(TOKEN_STORAGE_KEY));

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const INIT_COMPLETE = 'INIT_COMPLETE';

export function login(user, password) {
  return {
    type: LOGIN,
    payload: authServices.login(user, password)
  };
}

export function logout() {
  clearStoredToken();

  return {
    type: LOGOUT
  };
}

export function forceLogout() {
  clearStoredToken();

  return {
    type: FORCE_LOGOUT
  };
}

export function forgotPassword(email) {
  return {
    type: FORGOT_PASSWORD,
    payload: authServices.forgotPassword(email)
  };
}
